<div id="app-toolbar">
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-services"
        label=""
        #navBtnServices
        (click)="servicesMenu.toggle($event)">
        <span class="screen-lg"> {{ 'toolbar.services' | translate }} <i class="fa-regular fa-angle-down"></i> </span>
        <span class="screen-sm">YX</span>
    </button>
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-support"
        #navBtnSupport
        (click)="supportMenu.toggle($event)">
        <span class="screen-lg"> {{ 'toolbar.support' | translate }} <i class="fa-regular fa-angle-down"></i> </span>
        <span class="screen-sm"><i class="fa-light fa-circle-question"></i></span>
    </button>
    <button
        pButton
        type="button"
        class="p-button-secondary p-button-text nav-btn"
        id="nav-btn-user"
        #navBtnUser
        (click)="profileMenu.toggle($event)">
        <span style="min-height: 31px; display: flex; justify-content: center; flex-direction: column">
            <p id="nav-current-user-name">
                {{ currentUser?.shortName }}
            </p>
            <p id="nav-current-user-role" style="margin-top: 5px" *ngIf="currentUser?.roles?.includes(roles.ADMIN)">ADMIN</p>
        </span>
        <span id="user-avatar-container">
            <app-user-avatar></app-user-avatar>
        </span>
    </button>
</div>

<p-overlayPanel #servicesMenu styleClass="action-item-menu" [focusOnShow]="true">
    <app-menu-services
        #servicesMenu
        (closePopover)="servicesMenu.toggle(false); navBtnServices.focus()"></app-menu-services>
</p-overlayPanel>

<p-overlayPanel #supportMenu styleClass="action-item-menu" [focusOnShow]="true">
    <app-menu-support (closePopover)="supportMenu.toggle(false); navBtnSupport.focus()"></app-menu-support>
</p-overlayPanel>

<p-overlayPanel
    #profileMenu
    [styleClass]="'action-item-menu ' + (isSwitchGroupDisplayed ? 'switch-group-overlay' : '')"
    [focusOnShow]="true"
    (onHide)="isSwitchGroupDisplayed = false">
    <app-menu-profile
        [isSwitchGroupDisplayed]="isSwitchGroupDisplayed"
        (switchGroupDisplayChange)="isSwitchGroupDisplayed = $event"
        (closePopover)="
            profileMenu.toggle(false); navBtnUser.focus(); isSwitchGroupDisplayed = false
        "></app-menu-profile>
</p-overlayPanel>
